define([
	"dojo/_base/declare",
	"csi/_base/storage",
	"csi/comm",
	"csi/locale",
	"csi/reflection",
	"csi/view/ToolbarPluginSwitchboard",
	"csi/xml",
	"csi/xml/Query",
	"csi/state/rootStore"
], function(declare, storage, comm, locale, reflection, ToolbarPluginSwitchboard, xml, Query, { routerStore }) {

	var STORAGE_KEY = "MerchSecondaryPlanSubtype",
		_storeSecondaryTypes,
		_urlPlan,
		_urlSecondaryType;

	return declare(ToolbarPluginSwitchboard, {
		switchboardPath: "Child:Subtype/Child:Settings/Child:SecondarySubtypes",

		/**
		 * @override
		 * Add the filter for the selected secondary type
		 * Find the MerchVersion associated to the chose season
		 */
		onChangeItem: function(view, node) {
			view.set("urlSecondaryType", node ? node.$URL : null);
			_urlSecondaryType = view.get("urlSecondaryType");

			var rootClass = reflection.getClass(view.defView.getTypeNode());
			if (rootClass && rootClass.isDerivedFrom("MerchLevel"))
				view.relRoot.addQuery(new Query().RefAttr("Subtype", xml.OP_EQUALS, _urlSecondaryType), true);
			else if (rootClass && rootClass.isDerivedFrom("MerchVersion"))
				view.relRoot.addQuery(new Query().RefAttr("Subtype", xml.OP_EQUALS, _urlSecondaryType, "Child:__Parent__"), true);

			storage.set(STORAGE_KEY, _urlSecondaryType);
		},

		onRefresh: function() {
			// summary: reset secondary type store when refreshing view
			_storeSecondaryTypes = null;
		},

		_getStoreOptions: function(/*String*/url, /*Relationship?*/r) {
			// summary: if switching to new plan, then reset seasons store
			const urlPlan = routerStore.getBreadcrumbNodeURL("MerchPlan");
			if (urlPlan != _urlPlan) {
				_urlSecondaryType = _urlPlan ? null : storage.get(STORAGE_KEY);
				_storeSecondaryTypes = null;
				_urlPlan = urlPlan;
			}

			const options =  this.inherited(arguments, [_urlPlan, r]);
			const request = options?.request;
			if(request) {
				request.setBinaryQuery(comm.QUERY_XML, new Query().Node("Type", xml.OP_EQUALS, options.typeNode));
			}

			return options;
		},

		_onDefaultValue: function(/*String?*/preferredValue, /*String?*/defaultValue) {
			// summary: use previously selected season as default value if no value specified
			if (this.store && this.store.get(_urlSecondaryType)) {
				defaultValue = _urlSecondaryType;
			}

			this.inherited(arguments, [preferredValue, defaultValue]);
		},

		_setStoreAttr: function(/*Store?*/store) {
			// summary: always use season store, and track it when created
			this.inherited(arguments, [_storeSecondaryTypes]);
			_storeSecondaryTypes = this.store;
		}
	});
});
